<template>
  <div class="conteudoInterno" id="arrecadacao">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" :class="{
        setaScroll: setaScrollState,
      }">
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Collections</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcGreenBack"></span>
        </div>
        <div class="col66 spaceBetween top32">
          <div class="col49sub">
            <p>
              The figures presented on this page provide an overview of public performance royalty collections in Brazil, as administered by Ecad, the organization responsible for licensing these rights on behalf of Brazil's seven public performance collective management organizations, including UBC. They are intended to provide a comprehensive view of the Brazilian market.
            </p>
            <p>
              Under Brazil's current collective management system, licenses generally cover both authors' rights and neighboring rights for most—though not all—uses of music. Notable exceptions to neighboring rights licensing include live performances, where no sound recordings exist to support royalty distributions, as well as many digital streaming services, including both music streaming and video-on-demand (VOD) platforms, where neighboring rights are licensed directly by record companies on a global basis. UBC continues to work closely with Ecad to expand the scope of neighboring rights licensing to include additional digital services.</p>
          </div>
          <div class="col49sub">
            <p>
              It is also important to note that the figures presented here do not include mechanical royalties, as these rights are not collected through a centralized collective management system in Brazil.</p>
            <p>
              The final section of this report focuses specifically on UBC's performance, including the mechanical royalties we administer. However, those figures represent only the portion of the Brazilian market managed by UBC and should not be interpreted as representing the market as a whole.</p>
          </div>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            In 2025, Ecad collected a total of <span class="ubcGreen sanukBlack">BRL 2.105 billion</span> in public performance royalties, representing a <span class="ubcGreen sanukBlack">15% increase</span> over the previous year.
          </h4>
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h3>Collections by Usage Category</h3>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <PieChart1 v-if="isView" />
            </div>
          </div>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h3>Growth by Usage Category</h3>
          <span style="font-size: 12px; margin-top: 40px; margin-bottom: -30px; display: block;">BRL</span>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <LineChart1A />
            </div>
          </div>
        </div>
      </section>
      
      <section class="sectionRow top80">
        <div class="col40ponto4 ubcGreenBack">
          <!-- imagem -->
        </div>
        <div class="col49 spaceBetween">
          <div class="col100">
            <h4 class="h4Destaque ubcGreen sanukBlack">Highlights</h4>
          </div>
          <div class="col100 spaceBetween top50">
            <div class="col49sub">
              <div class="blockBigNumbers">
                <div>
                  <h6>Growth of</h6>
                  <h5 class="ubcGreen sanukBlack">47.2%</h5>
                  <h6>
                    in <span class="sanukBold">Digital</span>
                  </h6>
                </div>
                <p>
                  Another year in which the digital segment expanded strongly, further consolidating itself as an important revenue stream for collective management, driven by the continued growth in the subscriber base of streaming platforms and the expansion of VOD offerings.
                </p>
              </div>
              <div class="blockBigNumbers">
                <div>
                  <h6>Growth of</h6>
                  <h5 class="ubcGreen sanukBlack">13.2%</h5>
                  <h6>in <span class="sanukBold">Live Concerts</span></h6>
                </div>
                <p>
                  Major festivals and large-scale tours by both national and international artists across the country once again contributed to the expansion of this segment, which was among the most affected during the years of shutdown in the pandemic and has now fully recovered.
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";
import PieChart1 from "./Grafico1.vue";
import LineChart1A from "./Grafico2.vue";
import SwipperMobile from "./SwipperMobile.vue";

export default {
  name: "Collections-Page",
  props: ["clicked"],
  components: {
    PieChart1,
    LineChart1A,
    SwipperMobile
  },
  data() {
    return {
      setaScrollState: false,
      isView: false,
    };
  },
  destroyed() {
    this.myStopFunction();
  },
  mounted() {
    this.showSetaScroll();

    const conteudo = document.querySelector("#arrecadacao");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);

    setTimeout(() => {
      this.isView = true;
    }, 1500);
  },
  methods: {
    showSetaScroll: function () {
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if (alturaTela - 50 <= alturaDiv && boxABB.top == 148) {
          this.setaScrollState = true;
        } else {
          this.setaScrollState = false;
        }
      }, 1000);
    },
    myStopFunction: function () {
      clearInterval(this.refresh);
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blockBigNumbers {
  margin: 0 0 45px 0;
}

.blockBigNumbers div {
  margin: 0 0 8px 0;
}

.canvasGraphicArea {
  width: 100%;
  background: #cecece;
}

.graphContainer {
  padding-top: 20px;
  width: 100%;
  /* background-color: #168ECD; */
  overflow-x: scroll;
}

.graphContainer::-webkit-scrollbar {
  background-color: white;
  border-radius: 10px;
  width: 20px;
}

.graphContainer::-webkit-scrollbar-thumb {
  background-color: #8BC53F;
  border-radius: 10px;
  border: 5px solid white;
}

.graph {
  min-width: 500px;
  min-height: 250px;
}
</style>
